import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { LOGIN_KEY, REFRESHER } from '@share/constants';
import { RefresherStatus } from '../refresher-status.enum';

import { AuthenticationService } from '../authentication/authentication.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'conn-dashboard-error',
  templateUrl: './dashboard-error.component.html',
  styleUrls: ['./dashboard-error.component.css'],
  standalone: true,
})
export class DashboardErrorComponent implements OnInit, OnDestroy {
  private authService = inject(AuthenticationService);
  private logger = inject(NGXLogger);

  isLoading: boolean;
  broadcastChannel: BroadcastChannel;
  loadingInterval;
  waitCounter: number;
  MAX_WAIT_COUNTER = 5;
  loginUrl: string;

  constructor() {
    this.waitCounter = 0;
    this.isLoading = true;
    this.broadcastChannel = new BroadcastChannel(REFRESHER);
  }

  ngOnDestroy() {
    if (this.loadingInterval) {
      clearInterval(this.loadingInterval);
    }
    this.loginUrl = null;
  }

  ngOnInit() {
    this.loginUrl = this.authService.getFromSessionStorage(LOGIN_KEY);
    this.broadcastChannel.onmessage = (e) => {
      if (e && e.data === RefresherStatus.error && this.isLoading) {
        this.navigateToDashboard();
      } else if (e && e.data === RefresherStatus.done && this.isLoading) {
        this.navigateToDashboard();
      }
    };
    this.startup();
  }

  login() {
    this.authService.getNativeWindow().location.replace(this.loginUrl);
  }

  startup() {
    // Do not run interval during tests
    if (typeof window !== 'undefined' && 'karma' in window) {
      return;
    }
    this.loadingInterval = setInterval(() => {
      this.waitCounter++;
      this.logger.debug(
        'Waiting to receive an access token before proceeding.',
      );
      this.navigateToDashboard();
      if (this.waitCounter > this.MAX_WAIT_COUNTER) {
        this.isLoading = false;
        this.authService.getNativeWindow().clearInterval(this.loadingInterval);
      }
    }, 1500);
  }

  /**
   * when we are done loading or done waiting for a load to happen attempt to find an access token and navigate
   * to the appropriate dashboard.
   */
  navigateToDashboard() {
    const token = this.authService.getPeConnAccessToken();
    if (token && token.application) {
      this.authService
        .getNativeWindow()
        .location.replace(this.authService.getRedirectUrl());
    } else {
      this.waitCounter = this.MAX_WAIT_COUNTER + 1;
    }
  }
}
